/** 폰트·잉크 이름을 모를 때(불러오는 중·실패·못 찾은 id) id 를 그대로 보여 주는 글자 모양 — 두 칸 조각이 함께 쓴다. */
export const TEXT_OPTION_ID_FALLBACK_CLASS = 'font-mono text-xs break-all';
